<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('nav.telegram')" :title="$t('telegram.reconciliationTitle')">
      <div class="list__buttons">
        <div @click="sendConfig()" class="list__add-more">{{ $t("telegram.applySend") }}</div>
        <div @click="saveFilter()" class="list__add-more">{{ $t("common.save") }}</div>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list__filter">
        <div class="list__filter-item">
          <b>from: </b>
          <DatePicker v-model="filterData.date_from" :format="'DD.MM.YYYY'" />
        </div>
        <div class="list__filter-item">
          <b>to: </b>
          <DatePicker v-model="filterData.date_to" :format="'DD.MM.YYYY'" />
        </div>
        <div class="list__filter-item">
          <b>team: </b>
          <div class="check-selector">
            <div
              @click="resetTeam()"
              v-if="filterData.team.length > 0"
              class="check-selector__reset"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g id="Menu / Close_MD">
                  <path
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.team.length > 0">
                  <span class="check-selector__button-name-text">{{
                    filterData.team[0].name
                  }}</span>
                  <span v-if="filterData.team.length > 1" class="check-selector__button-name-count">
                    +{{ filterData.team.length - 1 }}
                  </span>
                </template>
                <template v-else> {{ $t("common.all") }} </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.team"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeTeam(item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addTeam(item)"
                  v-for="item in teamOptions"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(filter, index) in list" :key="index" class="list__filter">
        <div class="list__filter-items">
          <div class="list__filter-item title">
            <input type="text" v-model="list[index].title" :placeholder="$t('common.name')" />
          </div>
        </div>

        <div class="list__filter-items-title">Include:</div>
        <div class="list__filter-items">
          <div class="list__filter-item">
            <div class="check-selector">
              <div
                @click="resetCheck('language_id', [], index)"
                v-if="list[index].language_id.length > 0"
                class="check-selector__reset"
              >
                <svg
                  data-v-6ab518a4=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g data-v-6ab518a4="" id="Menu / Close_MD">
                    <path
                      data-v-6ab518a4=""
                      id="Vector"
                      d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                </svg>
              </div>
              <div class="check-selector__button">
                <div class="check-selector__button-name">
                  <template v-if="list[index].language_id.length > 0">
                    <span class="check-selector__button-name-text">{{
                      list[index].language_id[0].code
                    }}</span>
                    <span
                      v-if="list[index].language_id.length > 1"
                      class="check-selector__button-name-count"
                    >
                      +{{ list[index].language_id.length - 1 }}
                    </span>
                  </template>
                  <template v-else> Languages </template>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                  <path
                    d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                  ></path>
                </svg>
              </div>

              <div class="check-selector__list">
                <div class="check-selector__list-container">
                  <div class="check-selector__search">
                    <input v-model="search_languages" placeholder="Search Languages" />
                  </div>
                  <div class="check-selector__check-items">
                    <div
                      v-for="item in list[index].language_id"
                      :key="item.id"
                      class="check-selector__check-item"
                      @click="removeCheckElement('language_id', item, index)"
                    >
                      {{ item.code }} <span>-</span>
                    </div>
                  </div>
                  <div
                    @click="addCheckElement('language_id', item, index)"
                    v-for="item in getCheckList('languagesList', 'search_languages', 'code')"
                    :key="item.id"
                    class="check-selector__list-item"
                  >
                    {{ item.code }} <span>+</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="list__filter-item">
            <div class="check-selector">
              <div
                @click="resetCheck('integration_type', [], index)"
                v-if="list[index].integration_type.length > 0"
                class="check-selector__reset"
              >
                <svg
                  data-v-6ab518a4=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g data-v-6ab518a4="" id="Menu / Close_MD">
                    <path
                      data-v-6ab518a4=""
                      id="Vector"
                      d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                </svg>
              </div>
              <div class="check-selector__button">
                <div class="check-selector__button-name">
                  <template v-if="list[index].integration_type.length > 0">
                    <span class="check-selector__button-name-text">{{
                      list[index].integration_type[0].name
                    }}</span>
                    <span
                      v-if="list[index].integration_type.length > 1"
                      class="check-selector__button-name-count"
                    >
                      +{{ list[index].integration_type.length - 1 }}
                    </span>
                  </template>
                  <template v-else> Type Integration </template>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                  <path
                    d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                  ></path>
                </svg>
              </div>

              <div class="check-selector__list">
                <div class="check-selector__list-container">
                  <div class="check-selector__check-items">
                    <div
                      v-for="item in list[index].integration_type"
                      :key="item.id"
                      class="check-selector__check-item"
                      @click="removeCheckElement('integration_type', item, index)"
                    >
                      {{ item.name }} <span>-</span>
                    </div>
                  </div>
                  <div
                    @click="addCheckElement('integration_type', item, index)"
                    v-for="item in integrationSpecialTypeList"
                    :key="item.id"
                    class="check-selector__list-item"
                  >
                    {{ item.name }} <span>+</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="list__filter-item">
            <div class="check-selector">
              <div
                @click="resetCheck('integration_cost_type', [], index)"
                v-if="list[index].integration_cost_type.length > 0"
                class="check-selector__reset"
              >
                <svg
                  data-v-6ab518a4=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g data-v-6ab518a4="" id="Menu / Close_MD">
                    <path
                      data-v-6ab518a4=""
                      id="Vector"
                      d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                </svg>
              </div>
              <div class="check-selector__button">
                <div class="check-selector__button-name">
                  <template v-if="list[index].integration_cost_type.length > 0">
                    <span class="check-selector__button-name-text">{{
                      list[index].integration_cost_type[0].name
                    }}</span>
                    <span
                      v-if="list[index].integration_cost_type.length > 1"
                      class="check-selector__button-name-count"
                    >
                      +{{ list[index].integration_cost_type.length - 1 }}
                    </span>
                  </template>
                  <template v-else> Cost Type Integration </template>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                  <path
                    d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                  ></path>
                </svg>
              </div>

              <div class="check-selector__list">
                <div class="check-selector__list-container">
                  <div class="check-selector__check-items">
                    <div
                      v-for="item in list[index].integration_cost_type"
                      :key="item.id"
                      class="check-selector__check-item"
                      @click="removeCheckElement('integration_cost_type', item, index)"
                    >
                      {{ item.name }} <span>-</span>
                    </div>
                  </div>
                  <div
                    @click="addCheckElement('integration_cost_type', item, index)"
                    v-for="item in costTypeList"
                    :key="item.id"
                    class="check-selector__list-item"
                  >
                    {{ item.name }} <span>+</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="list__filter-item">
            <div class="check-selector">
              <div
                @click="resetCheck('direction', [], index)"
                v-if="list[index].direction.length > 0"
                class="check-selector__reset"
              >
                <svg
                  data-v-6ab518a4=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g data-v-6ab518a4="" id="Menu / Close_MD">
                    <path
                      data-v-6ab518a4=""
                      id="Vector"
                      d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                </svg>
              </div>
              <div class="check-selector__button">
                <div class="check-selector__button-name">
                  <template v-if="list[index].direction.length > 0">
                    <span class="check-selector__button-name-text">{{
                      list[index].direction[0].name
                    }}</span>
                    <span
                      v-if="list[index].direction.length > 1"
                      class="check-selector__button-name-count"
                    >
                      +{{ list[index].direction.length - 1 }}
                    </span>
                  </template>
                  <template v-else> Direction </template>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                  <path
                    d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                  ></path>
                </svg>
              </div>

              <div class="check-selector__list">
                <div class="check-selector__list-container">
                  <div class="check-selector__check-items">
                    <div
                      v-for="item in list[index].direction"
                      :key="item.id"
                      class="check-selector__check-item"
                      @click="removeCheckElement('direction', item, index)"
                    >
                      {{ item.name }} <span>-</span>
                    </div>
                  </div>
                  <div
                    @click="addCheckElement('direction', item, index)"
                    v-for="item in directionList"
                    :key="item.id"
                    class="check-selector__list-item"
                  >
                    {{ item.name }} <span>+</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="list__filter-item">
            <div class="check-selector">
              <div
                @click="resetCheck('integration', [], index)"
                v-if="list[index].integration.length > 0"
                class="check-selector__reset"
              >
                <svg
                  data-v-6ab518a4=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g data-v-6ab518a4="" id="Menu / Close_MD">
                    <path
                      data-v-6ab518a4=""
                      id="Vector"
                      d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                </svg>
              </div>
              <div class="check-selector__button">
                <div class="check-selector__button-name">
                  <template v-if="list[index].integration.length > 0">
                    <span class="check-selector__button-name-text">{{
                      list[index].integration[0].name
                    }}</span>
                    <span
                      v-if="list[index].integration.length > 1"
                      class="check-selector__button-name-count"
                    >
                      +{{ list[index].integration.length - 1 }}
                    </span>
                  </template>
                  <template v-else> Integrations </template>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                  <path
                    d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                  ></path>
                </svg>
              </div>

              <div class="check-selector__list">
                <div class="check-selector__list-container">
                  <div class="check-selector__search">
                    <input v-model="search_integration" placeholder="Search Integration" />
                  </div>
                  <div class="check-selector__check-items">
                    <div
                      v-for="item in list[index].integration"
                      :key="item.id"
                      class="check-selector__check-item"
                      @click="removeCheckElement('integration', item, index)"
                    >
                      {{ item.name }} <span>-</span>
                    </div>
                  </div>
                  <div
                    @click="addCheckElement('integration', item, index)"
                    v-for="item in getCheckList('integrationList', 'search_integration', 'name')"
                    :key="item.id"
                    class="check-selector__list-item"
                  >
                    {{ item.name }} <span>+</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-items-title">Exclude:</div>
        <div class="list__filter-items">
          <div class="list__filter-item">
            <div class="check-selector">
              <div
                @click="resetCheck('ex_language_id', [], index)"
                v-if="list[index].ex_language_id.length > 0"
                class="check-selector__reset"
              >
                <svg
                  data-v-6ab518a4=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g data-v-6ab518a4="" id="Menu / Close_MD">
                    <path
                      data-v-6ab518a4=""
                      id="Vector"
                      d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                </svg>
              </div>
              <div class="check-selector__button">
                <div class="check-selector__button-name">
                  <template v-if="list[index].ex_language_id.length > 0">
                    <span class="check-selector__button-name-text">{{
                      list[index].ex_language_id[0].code
                    }}</span>
                    <span
                      v-if="list[index].ex_language_id.length > 1"
                      class="check-selector__button-name-count"
                    >
                      +{{ list[index].ex_language_id.length - 1 }}
                    </span>
                  </template>
                  <template v-else> Ex Languages </template>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                  <path
                    d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                  ></path>
                </svg>
              </div>

              <div class="check-selector__list">
                <div class="check-selector__list-container">
                  <div class="check-selector__search">
                    <input v-model="search_languages" placeholder="Search Languages" />
                  </div>
                  <div class="check-selector__check-items">
                    <div
                      v-for="item in list[index].ex_language_id"
                      :key="item.id"
                      class="check-selector__check-item"
                      @click="removeCheckElement('ex_language_id', item, index)"
                    >
                      {{ item.code }} <span>-</span>
                    </div>
                  </div>
                  <div
                    @click="addCheckElement('ex_language_id', item, index)"
                    v-for="item in getCheckList('languagesList', 'search_languages', 'code')"
                    :key="item.id"
                    class="check-selector__list-item"
                  >
                    {{ item.code }} <span>+</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="list__filter-item">
            <div class="check-selector">
              <div
                @click="resetCheck('ex_integration', [], index)"
                v-if="list[index].ex_integration.length > 0"
                class="check-selector__reset"
              >
                <svg
                  data-v-6ab518a4=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g data-v-6ab518a4="" id="Menu / Close_MD">
                    <path
                      data-v-6ab518a4=""
                      id="Vector"
                      d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                </svg>
              </div>
              <div class="check-selector__button">
                <div class="check-selector__button-name">
                  <template v-if="list[index].ex_integration.length > 0">
                    <span class="check-selector__button-name-text">{{
                      list[index].ex_integration[0].name
                    }}</span>
                    <span
                      v-if="list[index].ex_integration.length > 1"
                      class="check-selector__button-name-count"
                    >
                      +{{ list[index].ex_integration.length - 1 }}
                    </span>
                  </template>
                  <template v-else> Ex Integrations </template>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                  <path
                    d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                  ></path>
                </svg>
              </div>

              <div class="check-selector__list">
                <div class="check-selector__list-container">
                  <div class="check-selector__search">
                    <input v-model="search_integration" placeholder="Search Integration" />
                  </div>
                  <div class="check-selector__check-items">
                    <div
                      v-for="item in list[index].ex_integration"
                      :key="item.id"
                      class="check-selector__check-item"
                      @click="removeCheckElement('ex_integration', item, index)"
                    >
                      {{ item.name }} <span>-</span>
                    </div>
                  </div>
                  <div
                    @click="addCheckElement('ex_integration', item, index)"
                    v-for="item in getCheckList('integrationList', 'search_integration', 'name')"
                    :key="item.id"
                    class="check-selector__list-item"
                  >
                    {{ item.name }} <span>+</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-items-title">Exclude Integration Name Contains:</div>
        <div class="list__filter-items">
          <div class="list__contain-items">
            <div
              v-for="(item, i) in list[index].integration_name_contains"
              :key="i"
              class="list__contain-item"
              @click="deleteContains(index, i)"
            >
              {{ item }}

              <div class="list__contain-item-delete">X</div>
            </div>
          </div>
        </div>
        <div class="list__filter-items">
          <div class="list__filter-item title">
            <input
              type="text"
              v-model="list[index].contains_items"
              :placeholder="$t('telegram.nameContainsPlaceholder')"
            />
          </div>
          <div @click="addContains(index)" class="list__add-more">{{ $t("common.add") }}</div>
        </div>

        <div @click="deleteFilter(index)" class="list__add-more">{{ $t("common.delete") }}</div>
      </div>
      <div @click="addFilter()" class="list__add-more">{{ $t("telegram.addFilterSet") }}</div>
    </ContentContainer>

    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import leadApi from "~/api/lead";
import userApi from "~/api/user";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import ModalError from "~/components/molecules/ModalError.vue";

export default {
  name: "TelegramListRec",
  metaInfo() {
    return {
      title: this.$t("nav.telegramReconciliation"),
    };
  },
  data() {
    return {
      filterData: {
        date_from: null,
        date_to: null,
        team: [],
      },
      search_languages: "",
      search_integration: "",
      contains_items: "",

      list: [],
      languagesList: [],
      teamList: [],

      integrationList: [],
      integrationSpecialTypeList: [
        {
          name: this.$t("common.all"),
          id: "all",
        },
        {
          name: "In",
          id: "in",
        },
        {
          name: "Out",
          id: "out",
        },
      ],
      costTypeList: [
        {
          name: this.$t("common.all"),
          id: "all",
        },
        {
          name: "CPL",
          id: "cpl",
        },
        {
          name: "CPA",
          id: "cpa",
        },
      ],
      directionList: [
        {
          name: this.$t("region.europe"),
          id: "eu",
        },
        {
          name: this.$t("region.australia"),
          id: "au",
        },
        {
          name: this.$t("region.canada"),
          id: "ca",
        },
        {
          name: this.$t("region.poland"),
          id: "pl",
        },
        {
          name: this.$t("region.germany"),
          id: "de",
        },
        {
          name: this.$t("region.france"),
          id: "fr",
        },
        {
          name: this.$t("region.romania"),
          id: "ro",
        },
      ],
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    ModalError,
    DatePicker,
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess"]),
    // id 0 — псевдо-команда для лидов без байера, на бэке это team_id IS NULL
    teamOptions() {
      return [{ id: 0, name: "Without Buyers" }, ...this.teamList];
    },
  },
  methods: {
    getCheckList(listKey, filterKey, nameKey) {
      const arr = this?.[listKey];
      const rawFilter = this?.[filterKey];

      if (!Array.isArray(arr)) return [];

      if (rawFilter == null || String(rawFilter).trim() === "") return arr;

      const filterStr = String(rawFilter).toLowerCase().trim();

      return arr.filter((item) => {
        const val = item?.[nameKey];
        if (val == null) return false;

        return String(val).toLowerCase().includes(filterStr);
      });
    },

    getList() {
      this.$store.commit("lead/setLoading", true);

      leadApi
        .getTelegramRec()
        .then((res) => {
          const list = res.data.metrics;

          if (res.data.date_from) {
            this.filterData.date_from = moment(res.data.date_from, "YYYY-MM-DD").toDate();
          } else {
            this.filterData.date_from = null;
          }

          if (res.data.date_to) {
            this.filterData.date_to = moment(res.data.date_to, "YYYY-MM-DD").toDate();
          } else {
            this.filterData.date_to = null;
          }

          this.filterData.team = (res.data.team_id || [])
            .map((id) => this.teamOptions.find((team) => team.id === id))
            .filter((team) => team !== undefined);

          list.forEach((element, index) => {
            const filter = element.include;
            const ex_filter = element.exclude;

            const fullFilterLang = [];
            const fullFilterExLang = [];
            const fullIntegrationType = [];
            const fullIntegrationCostType = [];
            const fullDirection = [];
            const fullIntegration = [];
            const fullExIntegration = [];

            if (filter.language_id) {
              filter.language_id.forEach((el) => {
                const lang = this.languagesList.filter((item) => {
                  return item.id == el;
                });
                fullFilterLang.push(lang[0]);
              });
            }

            if (filter.integration_type) {
              filter.integration_type.forEach((el) => {
                const lang = this.integrationSpecialTypeList.filter((item) => {
                  return item.id == el;
                });
                fullIntegrationType.push(lang[0]);
              });
            }

            if (filter.integration_cost_type) {
              filter.integration_cost_type.forEach((el) => {
                const lang = this.costTypeList.filter((item) => {
                  return item.id == el;
                });
                fullIntegrationCostType.push(lang[0]);
              });
            }

            if (filter.direction) {
              filter.direction.forEach((el) => {
                const lang = this.directionList.filter((item) => {
                  return item.id == el;
                });
                fullDirection.push(lang[0]);
              });
            }

            if (filter.integration_id) {
              filter.integration_id.forEach((el) => {
                const lang = this.integrationList.filter((item) => {
                  return item.id == el;
                });
                fullIntegration.push(lang[0]);
              });
            }

            if (ex_filter.language_id) {
              ex_filter.language_id.forEach((el) => {
                const lang = this.languagesList.filter((item) => {
                  return item.id == el;
                });
                fullFilterExLang.push(lang[0]);
              });
            }

            if (ex_filter.integration_id) {
              ex_filter.integration_id.forEach((el) => {
                const lang = this.integrationList.filter((item) => {
                  return item.id == el;
                });
                fullExIntegration.push(lang[0]);
              });
            }

            list[index].language_id = fullFilterLang;
            list[index].ex_language_id = fullFilterExLang;
            list[index].integration_type = fullIntegrationType;
            list[index].integration_cost_type = fullIntegrationCostType;
            list[index].direction = fullDirection;
            list[index].integration = fullIntegration;
            list[index].ex_integration = fullExIntegration;
            list[index].integration_name_contains = ex_filter.integration_name_contains || [];
            list[index].contains_items = "";
          });

          this.list = list;

          console.log(this.list, "list");
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },

    saveFilter() {
      this.$store.commit("lead/setLoading", true);

      const data = {
        date_from: moment(this.filterData.date_from).format("YYYY-MM-DD"),
        date_to: moment(this.filterData.date_to).format("YYYY-MM-DD"),
        team_id: this.filterData.team.map((item) => item.id),

        metrics: [],
      };

      this.list.forEach((element) => {
        const item = {};

        item.title = element.title;
        item.include = {};
        item.exclude = {};

        const filterLang = [];
        const integrationType = [];
        const integrationCostType = [];
        const integration = [];
        const direction = [];

        const filterExLang = [];
        const exIntegration = [];

        element.language_id.forEach((el) => {
          filterLang.push(el.id);
        });

        element.integration_type.forEach((el) => {
          integrationType.push(el.id);
        });

        element.integration_cost_type.forEach((el) => {
          integrationCostType.push(el.id);
        });

        element.integration.forEach((el) => {
          integration.push(el.id);
        });

        element.direction.forEach((el) => {
          direction.push(el.id);
        });

        element.ex_language_id.forEach((el) => {
          filterExLang.push(el.id);
        });

        element.ex_integration.forEach((el) => {
          exIntegration.push(el.id);
        });

        item.include.language_id = filterLang;
        item.include.integration_type = integrationType;
        item.include.integration_cost_type = integrationCostType;
        item.include.integration_id = integration;
        item.include.direction = direction;

        item.exclude.integration_name_contains = element.integration_name_contains || [];
        item.exclude.language_id = filterExLang;
        item.exclude.integration_id = exIntegration;

        data.metrics.push(item);
      });

      const send = {
        config: data,
      };

      console.log(send, "send");

      leadApi
        .saveTelegramRec(send)
        .then((res) => {
          this.getList();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },
    sendConfig() {
      this.$store.commit("lead/setLoading", true);
      let data = {};

      if (this.filterData.date_from && this.filterData.date_to) {
        data = {
          date_from: moment(this.filterData.date_from).format("YYYY-MM-DD"),
          date_to: moment(this.filterData.date_to).format("YYYY-MM-DD"),
        };
      }

      if (this.filterData.team.length > 0) {
        data.team_id = this.filterData.team.map((item) => item.id);
      }

      leadApi
        .sendTelegramRec(data)
        .then((res) => {
          this.getList();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },

    async getData() {
      try {
        const [languageRes, integrationRes, teamRes] = await Promise.all([
          leadApi.getLanguageList(),
          leadApi.getIntegrationAll(),
          userApi.getTeamAll(),
        ]);

        this.languagesList = languageRes.data.items;

        this.integrationList = integrationRes.data;

        this.teamList = teamRes.data.items;

        this.getList();
      } catch (error) {
        console.error(error);
      }
    },

    addCheckElement(key, value, index) {
      const foundObj = this.list[index][key].find((obj) => obj.id === value.id);
      if (foundObj == undefined) {
        this.list[index][key].push(value);
      }
    },
    removeCheckElement(key, value, index) {
      this.list[index][key] = this.list[index][key].filter((obj) => obj.id !== value.id);
    },
    resetCheck(key, reset, index) {
      this.list[index][key] = reset;
    },
    addTeam(value) {
      const foundObj = this.filterData.team.find((obj) => obj.id === value.id);
      if (foundObj == undefined) {
        this.filterData.team.push(value);
      }
    },
    removeTeam(value) {
      this.filterData.team = this.filterData.team.filter((obj) => obj.id !== value.id);
    },
    resetTeam() {
      this.filterData.team = [];
    },
    addFilter() {
      this.list.push({
        title: "",
        language_id: [],
        integration_type: [],
        integration_cost_type: [],
        direction: [],
        integration: [],
        ex_language_id: [],
        ex_integration: [],
        integration_name_contains: [],
        contains_items: "",
      });
    },
    deleteFilter(index) {
      this.list.splice(index, 1);
    },
    deleteContains(index, i) {
      this.list[index].integration_name_contains.splice(i, 1);
    },
    addContains(index) {
      this.list[index].integration_name_contains.push(this.list[index].contains_items);
      this.list[index].contains_items = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.check-selector {
  position: relative;

  &__reset {
    position: absolute;
    left: 5px;
    cursor: pointer;
    top: 9px;
    z-index: 11;
  }

  &__list {
    display: none;
    position: absolute;
    top: calc(100% - 20px);
    left: -100px;
    min-width: calc(300px + 40px);
    max-width: 400px;
    max-height: 340px;
    z-index: 100;
    padding: 20px;
  }

  &__list-container {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #3c2a1e;
    background: #fff;
    overflow-y: auto;
    max-height: 300px;
  }

  &__button {
    width: 170px;
    padding: 5px 5px 5px 30px;
    border: 1px solid #3c2a1e;
    border-radius: 5px;
    position: relative;
    height: 40px;
    display: flex;
    align-items: center;

    svg {
      margin-left: 10px;
    }
  }

  &__button-name {
    display: flex;
    align-items: center;
    width: 100px;
  }

  &__button-name-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__button-name-count {
    flex-shrink: 0;
    margin-left: 3px;
  }

  &__list-item {
    padding: 5px 5px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &:hover {
      background: #c7c3c0;
    }

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #3c2a1e;
      font-size: 15px;
      font-weight: 700;
      color: #fff;
      border-radius: 50px;
      line-height: 1;
    }
  }

  &__check-items {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #3c2a1e;
    padding: 10px 0;
    margin-bottom: 10px;
  }

  &__check-item {
    padding: 5px;
    border-radius: 5px;
    background: #3c2a1e;
    color: #fff;
    margin: 0 5px 5px 0;
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      font-size: 15px;
      font-weight: 700;
      color: #3c2a1e;
      border-radius: 50px;
      margin-left: 10px;
      line-height: 1;
    }
  }

  &:hover {
    .check-selector__list {
      display: block !important;
    }
  }

  &:focus-within {
    .check-selector__list {
      display: block !important;
    }
  }
}
/deep/.custom-table__header,
/deep/.custom-table__row {
  display: grid;
  grid-template-columns: 0.4fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 2fr 1fr 1fr !important;
}

/deep/.modal-container {
  height: fit-content;
  max-height: 90vh;
  overflow-y: auto;
}

.list {
  &__contain-items {
    display: flex;
    padding: 10px 0;
  }

  &__contain-item {
    display: flex;
    align-items: center;
    margin: 0 10px 10px 0;
    border: 1px solid gray;
    border-radius: 5px;
    padding: 5px;
  }

  &__contain-item-delete {
    margin-left: 10px;
    cursor: pointer;
    font-size: 10px;
    line-height: 1;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid gray;
    border-radius: 50px;
  }

  &__buttons {
    display: flex;
  }
  &__add-more {
    width: fit-content;
    padding: 10px 20px;
    background: #3c2a1e;
    color: #fff;
    border-radius: 10px;
    font-weight: 700;
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  &__table-title {
    padding: 20px 0 10px;
    font-size: 24px;
    font-weight: 700;
  }
  &__filter-favorite {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    font-size: 18px;
    cursor: pointer;

    svg {
      margin-left: 5px;
    }

    .inner {
      fill: #fff !important;
    }
    .border {
      stroke: rgb(148, 22, 22) !important;
      fill: none !important;
    }

    &.active {
      .inner {
        fill: rgb(148, 22, 22) !important;
      }
    }
  }
  &__confirm-log {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid gainsboro;
    margin-bottom: 10px;
  }

  &__confirm-log-type {
    padding: 20px;
    background: gainsboro;
    border-radius: 10px;
    margin-right: 10px;
  }

  &__confirm-log-time {
    margin-left: auto;
    padding-left: 10px;
  }

  &__filter {
    padding: 10px;
    background: #ebe9e8;
    margin-bottom: 10px;
    border-radius: 5px;
  }

  &__filter-items-title {
    font-size: 16px;
    font-weight: 700;
    padding-bottom: 10px;
  }

  &__filter-items {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  &__filter-item {
    width: 170px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.title {
      width: 500px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }
  }

  &__filter-button {
    width: 100px;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }
}
</style>
